<template>
  <v-footer v-if="hasSelection" app>
    <h3>{{ totalSelected }} Posts Selected</h3>
    <v-spacer></v-spacer>
    <v-btn class="mt-4 mb-4" @click="clearSelection">Clear</v-btn>
    <v-btn color="primary" class="ma-4">Export</v-btn>
  </v-footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    hasSelection() {
      return this.selected.length > 0 ? true : false;
    },
    selected() {
      return this.$store.getters.selected;
    },
    totalSelected() {
      return this.selected.length;
    }
  },
  methods: {
    clearSelection() {
      this.$store.dispatch("clearSelection");
    }
  }
};
</script>
